import { render, staticRenderFns } from "./RegisterTabs.vue?vue&type=template&id=15bfb7ce"
import script from "./RegisterTabs.vue?vue&type=script&lang=js"
export * from "./RegisterTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports